import Vue from 'vue'
import Router from 'vue-router'
import filter from "../plugins/filters";

const Index = () => import('@/pages/index');
const Register = () => import('@/pages/register');
const Login = () => import('@/pages/login');
const Binding = () => import('@/pages/Binding');
const ForgetPwd = () => import('@/pages/forgetPwd');
const ResetPwd = () => import('@/pages/resetPwd');
const Sale = () => import('@/pages/sale/index');
const SaleList = () => import('@/pages/sale/saleList');
const Category = () => import('@/pages/products/category');
const newWine = () => import('@/pages/products/newWine');
const eu = () => import('@/pages/eu/eu');
const SearchList = () => import('@/pages/products/searchList');
const ShoppingCart = () => import('@/pages/shopcart');
const OrderPay = () => import('@/pages/orderpay/index');
const Pay2 = () => import('@/pages/pay/pay2')
const ToPay = () => import('@/pages/pay/index');
const ToRePay = () => import('@/pages/pay/rePay');
const WxPay = () => import('@/pages/pay/wx_pay');
const OrderToPay = () => import('@/pages/pay/orderToPay')
const PaySuccess = () => import('@/pages/pay/paySuccess')
const ProductDetail = () => import('@/pages/products/productDetail');
const User = () => import('@/pages/users');
const Info = () => import('@/pages/users/info');
const EAddress = () => import('@/pages/users/userAddress');
const EModifyemail = () => import('@/pages/users/modifyEmail');
const EModifymobile = () => import('@/pages/users/modifyMobile');
const EModifypassword = () => import('@/pages/users/modifyPassword');
const EpointExchange = () => import('@/pages/users/pointExchange');
const OnlineRecharge = () => import('@/pages/users/onlineRecharge');
const EpointDetail = () => import('@/pages/users/pointDetail');
const OrderLetter = () => import('@/pages/users/orderLetter');
const KeepList = () => import('@/pages/users/keepList');
const CollectionGoods = () => import('@/pages/users/collectionGoods');
const Massage = () => import('@/pages/users/massage');
const SystemMass = () => import('@/pages/users/systemMass');
const EventNotice = () => import('@/pages/users/eventNotice');
const AccountDetails = () => import('@/pages/users/accountDetails');
const EperGift = () => import('@/pages/users/eperGift');
const Coupon = () => import('@/pages/users/coupon');
const BuyEperCard = () => import('@/pages/users/buyEperCard');
const ArrivalRemind = () => import('@/pages/users/arrivalRemind');
const Invitation = () => import('@/pages/users/invitation')
const Rainbow = () => import('@/pages/rainbow');
const RainbowProductDetail = () => import('@/pages/rainbow/productDetail');
const Redwine = () => import('@/pages/redwine');
const Winelist = () => import('@/pages/redwine/wineList')
const RedwineFilterList = () => import('@/pages/redwine/filterList');
const About = () => import('@/pages/about/index');
const IntegralMall = () => import('@/pages/integralMall/index');
const IntegralChange = () => import('@/pages/integralMall/integralChange');
const IntegralDetail = () => import('@/pages/integralMall/integralDetail');
const MonthlyNutrition = () => import('@/pages/monthlyNutrition/index');
const MonthlyDetail = () => import('@/pages/monthlyNutrition/monthlyDetail');
const EperBox = () => import('@/pages/eperBox/index');
const EperBoxDetail = () => import('@/pages/eperBox/eperBoxDetail');
const Nopage = () => import('@/pages/nopage/nopage');
const HistoryOrdersList = () => import('@/pages/users/historyOrderList');
const RequestInvoice = () => import('@/pages/users/requestInvoice');
const HistoryOrderDetail = () => import('@/pages/users/historyOrderDetail');
const Supplier = () => import('@/pages/butique/supplier');
const SupplierDetail = () => import('@/pages/butique/supplierDetail');
const NewLetter = () => import('@/pages/newLetter/index');
const Scro = () => import('@/pages/scroll')
const OrderFood = () => import('@/pages/OrderFood.vue');
const UseCoupon = () => import('@/pages/products/useCoupon.vue');
const PromCategoryList = () => import('@/pages/products/PromCategoryList.vue');
const newCategory = () => import('@/pages/products/newcategory.vue')
Vue.use(Router);

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/', name: 'Index', component: Index, meta: {
        zh: {
          title: '這樣生活-专业选好物',
          keywords: 'Epermarket,這樣生活,这样生活,进口超市,精品超市,精品进口超市,生鲜,奶酪,牛排,牛奶,三文鱼,雪鱼,矿泉水,红酒,海鲜,有机蔬菜,有机水果,有机产品',
          description: 'Epermarket这样生活线上精品进口超市，9年外籍人士及中国高端人士服务经验。超8000+全球食材汇集。自营冷链物流上海当日送达。'
        },
        en: {
          title: 'Epermarket | Shanghai online supermarket | Quality imported grocery delivery',
          keywords: 'shanghai online supermarket, China online supermarket, Beijing online supermarket, grocery shanghai, imported food, expat supermarket, online grocery store, home delivery groceries, imported meat, cheese shanghai, organic food shanghai, baby food, grocery delivery, gourmet cheese, Guangzhou, shenzhen',
          description: 'More than 8000 fresh and quality imported groceries, delivered to your door. Fresh meat to organic vegetables, we have everything you need.'
        },
        fr: {
          title: 'Epermarket–Supermarché en ligne à  Shanghai.  Livraison à domicile.',
          keywords: 'supermarché en ligne shanghai, épicerie shanghai, nourriture importée, supermarché expats, supermarché en ligne, livraison de nourriture shanghai, viande importée, fromage shanghai, livraison à domicile,  nourriture bio shanghai, vin shanghai, produits halal, café shanghai',
          description: 'Epermarket - le supermarché en ligne pour Shanghai expats. Produits de qualité, sécurité alimentaire, prix compétitifs & tracabilité de chaque produit '
        }
      }
    },
    { path: '/register', name: 'register', component: Register },
    { path: '/login', name: 'login', component: Login },
    { path: '/binding', name: 'binding', component: Binding },
    { path: '/forgetPwd', name: "forgetPwd", component: ForgetPwd },
    { path: "/resetPwd", name: "resetPwd", component: ResetPwd },
    { path: '/sale', name: 'sale', component: Sale },
    { path: '/saleList', name: 'saleList', component: SaleList },
    {
      path: '/category', name: 'category', component: Category, meta: {
        zh: {
          title: '這樣生活-专业选好物',
          keywords: 'Epermarket,這樣生活,这样生活,进口超市,精品超市,精品进口超市,生鲜,奶酪,牛排,牛奶,三文鱼,雪鱼,矿泉水,红酒,海鲜,有机蔬菜,有机水果,有机产品',
          description: 'Epermarket这样生活线上精品进口超市，9年外籍人士及中国高端人士服务经验。超8000+全球食材汇集。自营冷链物流上海当日送达。'
        },
        en: {
          title: 'Epermarket | Shanghai online supermarket | Quality imported grocery delivery',
          keywords: 'shanghai online supermarket, China online supermarket, Beijing online supermarket, grocery shanghai, imported food, expat supermarket, online grocery store, home delivery groceries, imported meat, cheese shanghai, organic food shanghai, baby food, grocery delivery, gourmet cheese, Guangzhou, shenzhen',
          description: 'More than 8000 fresh and quality imported groceries, delivered to your door. Fresh meat to organic vegetables, we have everything you need.'
        },
        fr: {
          title: 'Epermarket–Supermarché en ligne à  Shanghai.  Livraison à domicile.',
          keywords: 'supermarché en ligne shanghai, épicerie shanghai, nourriture importée, supermarché expats, supermarché en ligne, livraison de nourriture shanghai, viande importée, fromage shanghai, livraison à domicile,  nourriture bio shanghai, vin shanghai, produits halal, café shanghai',
          description: 'Epermarket - le supermarché en ligne pour Shanghai expats. Produits de qualité, sécurité alimentaire, prix compétitifs & tracabilité de chaque produit '
        }
      }
    },
    {
      path: '/newWine', name: 'newWine', component: newWine, meta: {
        zh: {
          title: '這樣生活-专业选好物',
          keywords: 'Epermarket,這樣生活,这样生活,进口超市,精品超市,精品进口超市,生鲜,奶酪,牛排,牛奶,三文鱼,雪鱼,矿泉水,红酒,海鲜,有机蔬菜,有机水果,有机产品',
          description: 'Epermarket这样生活线上精品进口超市，9年外籍人士及中国高端人士服务经验。超8000+全球食材汇集。自营冷链物流上海当日送达。'
        },
        en: {
          title: 'Epermarket | Shanghai online supermarket | Quality imported grocery delivery',
          keywords: 'shanghai online supermarket, China online supermarket, Beijing online supermarket, grocery shanghai, imported food, expat supermarket, online grocery store, home delivery groceries, imported meat, cheese shanghai, organic food shanghai, baby food, grocery delivery, gourmet cheese, Guangzhou, shenzhen',
          description: 'More than 8000 fresh and quality imported groceries, delivered to your door. Fresh meat to organic vegetables, we have everything you need.'
        },
        fr: {
          title: 'Epermarket–Supermarché en ligne à  Shanghai.  Livraison à domicile.',
          keywords: 'supermarché en ligne shanghai, épicerie shanghai, nourriture importée, supermarché expats, supermarché en ligne, livraison de nourriture shanghai, viande importée, fromage shanghai, livraison à domicile,  nourriture bio shanghai, vin shanghai, produits halal, café shanghai',
          description: 'Epermarket - le supermarché en ligne pour Shanghai expats. Produits de qualité, sécurité alimentaire, prix compétitifs & tracabilité de chaque produit '
        }
      }
    },
    {
      path: '/newcategory', name: 'newcategory', component: newCategory, meta: {
        zh: {
          title: '這樣生活-专业选好物',
          keywords: 'Epermarket,這樣生活,这样生活,进口超市,精品超市,精品进口超市,生鲜,奶酪,牛排,牛奶,三文鱼,雪鱼,矿泉水,红酒,海鲜,有机蔬菜,有机水果,有机产品',
          description: 'Epermarket这样生活线上精品进口超市，9年外籍人士及中国高端人士服务经验。超8000+全球食材汇集。自营冷链物流上海当日送达。'
        },
        en: {
          title: 'Epermarket | Shanghai online supermarket | Quality imported grocery delivery',
          keywords: 'shanghai online supermarket, China online supermarket, Beijing online supermarket, grocery shanghai, imported food, expat supermarket, online grocery store, home delivery groceries, imported meat, cheese shanghai, organic food shanghai, baby food, grocery delivery, gourmet cheese, Guangzhou, shenzhen',
          description: 'More than 8000 fresh and quality imported groceries, delivered to your door. Fresh meat to organic vegetables, we have everything you need.'
        },
        fr: {
          title: 'Epermarket–Supermarché en ligne à  Shanghai.  Livraison à domicile.',
          keywords: 'supermarché en ligne shanghai, épicerie shanghai, nourriture importée, supermarché expats, supermarché en ligne, livraison de nourriture shanghai, viande importée, fromage shanghai, livraison à domicile,  nourriture bio shanghai, vin shanghai, produits halal, café shanghai',
          description: 'Epermarket - le supermarché en ligne pour Shanghai expats. Produits de qualité, sécurité alimentaire, prix compétitifs & tracabilité de chaque produit '
        }
      }
    },
    {
      path: '/PromCategoryList', name: 'PromCategoryList', component: PromCategoryList, meta: {
        zh: {
          title: '這樣生活-专业选好物',
          keywords: 'Epermarket,這樣生活,这样生活,进口超市,精品超市,精品进口超市,生鲜,奶酪,牛排,牛奶,三文鱼,雪鱼,矿泉水,红酒,海鲜,有机蔬菜,有机水果,有机产品',
          description: 'Epermarket这样生活线上精品进口超市，9年外籍人士及中国高端人士服务经验。超8000+全球食材汇集。自营冷链物流上海当日送达。'
        },
        en: {
          title: 'Epermarket | Shanghai online supermarket | Quality imported grocery delivery',
          keywords: 'shanghai online supermarket, China online supermarket, Beijing online supermarket, grocery shanghai, imported food, expat supermarket, online grocery store, home delivery groceries, imported meat, cheese shanghai, organic food shanghai, baby food, grocery delivery, gourmet cheese, Guangzhou, shenzhen',
          description: 'More than 8000 fresh and quality imported groceries, delivered to your door. Fresh meat to organic vegetables, we have everything you need.'
        },
        fr: {
          title: 'Epermarket–Supermarché en ligne à  Shanghai.  Livraison à domicile.',
          keywords: 'supermarché en ligne shanghai, épicerie shanghai, nourriture importée, supermarché expats, supermarché en ligne, livraison de nourriture shanghai, viande importée, fromage shanghai, livraison à domicile,  nourriture bio shanghai, vin shanghai, produits halal, café shanghai',
          description: 'Epermarket - le supermarché en ligne pour Shanghai expats. Produits de qualité, sécurité alimentaire, prix compétitifs & tracabilité de chaque produit '
        }
      }
    },
    { path: '/eu', name: 'eu', component: eu },
    { path: '/searchList', name: 'searchList', component: SearchList },
    { path: '/shopcart', name: 'shopcart', component: ShoppingCart },
    { path: '/orderpay', name: 'orderpay', component: OrderPay },
    { path: '/pay2', name: 'pay2', component: Pay2 },
    { path: '/toPay', name: 'toPay', component: ToPay },
    { path: '/toRePay', name: 'toRePay', component: ToRePay },
    { path: '/wxPay', name: 'wxPay', component: WxPay },
    { path: '/orderToPay', name: 'orderToPay', component: OrderToPay },
    { path: '/paySuccess', name: 'paysuccess', component: PaySuccess },
    {
      path: '/productDetail', name: 'productDetail', component: ProductDetail, meta: {
        zh: {
          title: '這樣生活-专业选好物',
          keywords: 'Epermarket,這樣生活,这样生活,进口超市,精品超市,精品进口超市,生鲜,奶酪,牛排,牛奶,三文鱼,雪鱼,矿泉水,红酒,海鲜,有机蔬菜,有机水果,有机产品',
          description: 'Epermarket这样生活线上精品进口超市，9年外籍人士及中国高端人士服务经验。超8000+全球食材汇集。自营冷链物流上海当日送达。'
        },
        en: {
          title: 'Epermarket | Shanghai online supermarket | Quality imported grocery delivery',
          keywords: 'shanghai online supermarket, China online supermarket, Beijing online supermarket, grocery shanghai, imported food, expat supermarket, online grocery store, home delivery groceries, imported meat, cheese shanghai, organic food shanghai, baby food, grocery delivery, gourmet cheese, Guangzhou, shenzhen',
          description: 'More than 8000 fresh and quality imported groceries, delivered to your door. Fresh meat to organic vegetables, we have everything you need.'
        },
        fr: {
          title: 'Epermarket–Supermarché en ligne à  Shanghai.  Livraison à domicile.',
          keywords: 'supermarché en ligne shanghai, épicerie shanghai, nourriture importée, supermarché expats, supermarché en ligne, livraison de nourriture shanghai, viande importée, fromage shanghai, livraison à domicile,  nourriture bio shanghai, vin shanghai, produits halal, café shanghai',
          description: 'Epermarket - le supermarché en ligne pour Shanghai expats. Produits de qualité, sécurité alimentaire, prix compétitifs & tracabilité de chaque produit '
        }
      }
    },
    { path: '/rainbow', name: "rainbow", component: Rainbow },
    { path: '/rainbow/productDetail', name: 'rainbowProductDetail', component: RainbowProductDetail },
    { path: '/redwine', name: "redwine", component: Redwine },
    { path: '/wineList', name: "wineList", component: Winelist },
    { path: '/redwine/filterList', component: RedwineFilterList },
    {
      path: '/user', name: 'user', component: User,
      children: [
        { path: '/user/userInfo', component: Info },
        { path: '/user/userAddress', component: EAddress },
        { path: '/user/modifyEmail', component: EModifyemail },
        { path: '/user/modifyMobile', component: EModifymobile },
        { path: '/user/modifyPassword', component: EModifypassword },
        { path: '/user/pointExchange', component: EpointExchange },
        { path: '/user/onlineRecharge', component: OnlineRecharge },
        { path: '/user/pointDetail', component: EpointDetail },
        { path: '/user/orderLetter', component: OrderLetter },
        { path: '/user/KeepList', component: KeepList },
        { path: '/user/collectionGoods', component: CollectionGoods },
        { path: '/user/massage', component: Massage },
        { path: '/user/systemMass', component: SystemMass },
        { path: '/user/eventNotice', component: EventNotice },
        { path: '/user/accountDetails', component: AccountDetails },
        { path: '/user/eperGift', component: EperGift },
        { path: '/user/coupon', component: Coupon },
        { path: '/user/buyEperCard', component: BuyEperCard },
        { path: '/user/arrivalRemind', component: ArrivalRemind },
        { path: '/user/invitation', component: Invitation },
        { path: '/user/getOrdersList', component: HistoryOrdersList },
        { path: '/user/requestInvoice', component: RequestInvoice },
        { path: '/user/historyOrderDetail', component: HistoryOrderDetail }
      ]
    },
    { path: '/about', name: 'about', component: About },
    { path: '/integralMall', name: 'integralMall', component: IntegralMall },
    { path: '/integralChange', name: 'integralChange', component: IntegralChange },
    { path: '/integralDetail', name: 'integralDetail', component: IntegralDetail },
    { path: '/monthlyNutrition', name: 'monthlyNutrition', component: MonthlyNutrition },
    { path: '/monthlyDetail', name: 'monthlyDetail', component: MonthlyDetail },
    { path: '/eperBox', name: 'eperBox', component: EperBox },
    { path: '/eperBoxDetail', name: 'eperBoxDetail', component: EperBoxDetail },
    { path: '*', component: Index },
    { path: '/supplier', name: 'nopage', component: Supplier },
    { path: '/newLetter', name: 'newLetter', component: NewLetter },
    { path: '/supplierDetail', name: 'supplierDetail', component: SupplierDetail },
    { path: '/scroll', component: Scro },
    { path: '/OrderFood', component: OrderFood},
    { path: '/useCoupon', component: UseCoupon}
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});
router.beforeEach((to, from, next) => {
  // console.log('路由参数----',to);
  let langName;
  let num = to.fullPath.indexOf("formLang");
  if (num > -1) {
    langName = parseInt(to.fullPath.substr(num + 9, 1));
    localStorage.setItem('lang', JSON.stringify(langName));
    window.location.href = '/'

  }
  // var os = function (){
  //   var ua = navigator.userAgent,
  //   isWindowsPhone = /(?:Windows Phone)/.test(ua),
  //   isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
  //   isAndroid = /(?:Android)/.test(ua),
  //   isFireFox = /(?:Firefox)/.test(ua),
  //   isChrome = /(?:Chrome|CriOS)/.test(ua),
  //   isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
  //   isPhone = /(?:iPhone)/.test(ua) && !isTablet,
  //   isPc = !isPhone && !isAndroid && !isSymbian;
  //   return {
  //     isTablet: isTablet,
  //     isPhone: isPhone,
  //     isAndroid: isAndroid,
  //     isPc: isPc
  //   };	
  // }();
   
  // if (os.isAndroid || os.isPhone) {   
  //    alert("手机" );
  // } else if (os.isTablet) {
  //     alert("平板" );
  // } else if (os.isPc) {
  //     alert("电脑" );
  // }
  // 兼容 移动端  https://m.nogogo.cn/pages/index
  if(isMobileOrTablet()){
  // if (navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) || window.innerWidth < 1050) {

    let productDetailM = to.fullPath.indexOf("/productDetail");
    let categoryM = to.fullPath.indexOf("/category");
    let hFtypeList = to.query.ProductCataID   //分类ID
    let ProductCataJumpType = to.query.ProductCataJumpType

    // console.log('productDetailM', productDetailM);
    // console.log('to.fullPath.indexOf', to.query.ProductCataID);


    //H5  :  http://localhost:8081/epermarketSub/typeList?id=322&isShowCN=0&name=Fresh%2520Fruit

    if (productDetailM > -1) {
      //商品详情页
      window.location.href = "https://m.nogogo.cn/epermarketSub/productDetail?id=" + to.query.id
      // window.location.href = "http://localhost:8082/epermarketSub/productDetail?id=" + to.query.id
    } else if (hFtypeList != undefined && hFtypeList > 0) {
      // 品类页面
      // 特殊跳转
      if (ProductCataJumpType == 10) {
        // window.location.href = "http://localhost:8082/epermarketSub/wine"
        window.location.href = "https://m.nogogo.cn/epermarketSub/wine"
      } else if (ProductCataJumpType == 20 || ProductCataJumpType == 30) {
        window.location.href = `https://m.nogogo.cn/epermarketSub/flylu?id=${to.query.ProductCataID}&isShowCN=0&name=""`
        // window.location.href = `http://localhost:8082/epermarketSub/flylu?id=${to.query.ProductCataID}&isShowCN=0&name=""`
      } else {
        window.location.href = `https://m.nogogo.cn/epermarketSub/typeList?id=${to.query.ProductCataID}&isShowCN=0&name=""`
        // window.location.href = `http://localhost:8082/epermarketSub/typeList?id=${to.query.ProductCataID}&isShowCN=0&name=""`
      }
    }

    else if (categoryM > -1 && to.query.WebFunctionID && to.query.WebFunctionID != '') {
      //专区
      window.location.href = `https://m.nogogo.cn/epermarketSub/categoryList?WebFunctionID=${to.query.WebFunctionID}&isShowSelect=1`
      // window.location.href = `http://localhost:8082/epermarketSub/categoryList?WebFunctionID=${to.query.WebFunctionID}&isShowSelect=1`
    } else if (categoryM > -1 && to.query.PropertyIDs && to.query.PropertyIDs != '') {
      window.location.href = `https://m.nogogo.cn/epermarketSub/categoryList?id=${to.query.PropertyIDs}&isShowSelect=1`
      // window.location.href = `http://localhost:8082/epermarketSub/categoryList?id=${to.query.PropertyIDs}&isShowSelect=1`
    } else if(to.fullPath.indexOf("/register") > -1 && to.fullPath.indexOf("InviteCode") > -1){//PC分享H5
      console.log("PC分享H5打开",`https://m.nogogo.cn/pages/Authorization/language?path=${encodeURIComponent('/pages/Authorization/register' + '?InviteCode=' + to.query.InviteCode)}`);
      window.location.href = `https://m.nogogo.cn/pages/Authorization/language?path=${encodeURIComponent('/pages/Authorization/register' + '?InviteCode=' + to.query.InviteCode)}`
    } else {
      window.location.href = "https://m.nogogo.cn"

    }
    return


  }


  let lang = localStorage.getItem('lang')

  let title = '', keywords = '', description = '';

  if (lang) {
    if (JSON.stringify(to.meta) != "{}") {
      if (lang == 1) {
        title = to.meta.zh.title
        keywords = to.meta.zh.keywords
        description = to.meta.zh.description
      } else if (lang == 2) {
        title = to.meta.en.title
        keywords = to.meta.en.keywords
        description = to.meta.en.description
      } else if (lang == 3) {
        title = to.meta.fr.title
        keywords = to.meta.fr.keywords
        description = to.meta.fr.description
      }
    }
  }
  if (to.path == '/' || to.path == '/category' || to.path == '/productDetail') {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', description)
    meta.content = to.meta.content;
    head[0].appendChild(meta);
    document.title = title;
  }

  if (localStorage.getItem("isok") == 1) {
  } else {
    localStorage.removeItem("lang");
    localStorage.removeItem("cityInfo");
    localStorage.setItem("isok", 1);
  }


  //用户未登录
  if (!localStorage.getItem('Token')) {
    if (to.path.indexOf('/user') >= 0) {
      return next('/login')
    }
  }
  // 如果访问是注册页 并且有分享ID 并且 是已经登录的情况下 访问首页
  if(to.path == "/register" && to.query.InviteCode && localStorage.getItem('Token')){
    return next('/')
  }else if(to.path == "/register" && to.query.InviteCode){
    if (!filter.readData("TempId")) {
      const setUuid = filter.getUUID();
      filter.setData("TempId", setUuid);
    }
    return next()
  }
  next();
});

function isMobileOrTablet() {
  // 1. 通过 UA 检测常见移动设备/平板关键词
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'android', 'iphone', 'ipad', 'ipod', 'windows phone',
    'blackberry', 'webos', 'symbian', 'bb10', 'ios'
  ];
  const isMobileUA = mobileKeywords.some(keyword => userAgent.includes(keyword));

  // 2. 辅助检测：屏幕宽度（平板/手机通常宽度 < 1024px）
  const isSmallScreen = window.innerWidth < 1024;

  // 3. 兜底：检测触摸事件（移动设备通常支持触摸）
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 满足 UA 是移动设备，或小屏+触摸设备，判定为移动/平板
  return isMobileUA || (isSmallScreen && isTouchDevice);
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js